export default [
  'on_error',
  'on_clear_error',
  'on_change_locale',
  'on_change_initialize',
  'on_change_title',
  'select_university',
  'select_organization',
];
